/**
 * Fiyat metinlerini sayıya çevirir.
 *
 * Ürün fiyatı panelde serbest metin olarak giriliyor ("£45.00", "45", "£1,200.50").
 * Sepet toplamı eskiden `parseFloat(price.replace(/[^\d]/g, ''))` ile hesaplanıyordu;
 * bu, ondalık ayıracını da silip "£45.00"ı **4500** yapıyordu. Sipariş e-postasına
 * "Toplam: £4,500" yazılıyordu — 100 kat fazla.
 *
 * Kurallar:
 *  - Para birimi simgesi, boşluk ve harfler atılır.
 *  - Son görülen ',' veya '.' ondalık ayıracı sayılır; ondan öncekiler binlik ayıracıdır.
 *    ("1.234,56" → 1234.56, "1,234.56" → 1234.56)
 *  - İstisna: son ayıraçtan sonra tam 3 hane varsa ve başka ayıraç yoksa bu binliktir.
 *    ("1,200" → 1200, "£1.500" → 1500)
 *  - Çözülemeyen değer 0 döner (NaN sepet toplamını bozmasın).
 */
export function parsePrice(value) {
  if (typeof value === 'number') return Number.isFinite(value) ? value : 0;
  if (typeof value !== 'string') return 0;

  const cleaned = value.replace(/[^\d.,-]/g, '').trim();
  if (!cleaned) return 0;

  const lastComma = cleaned.lastIndexOf(',');
  const lastDot = cleaned.lastIndexOf('.');
  const lastSep = Math.max(lastComma, lastDot);

  let normalized;
  if (lastSep === -1) {
    normalized = cleaned;
  } else {
    const decimals = cleaned.length - lastSep - 1;
    const otherSepCount = (cleaned.match(/[.,]/g) || []).length - 1;
    // Tek ayıraç + tam 3 hane → binlik ayıracı ("1,200" = 1200)
    if (decimals === 3 && otherSepCount === 0) {
      normalized = cleaned.replace(/[.,]/g, '');
    } else {
      normalized = cleaned.slice(0, lastSep).replace(/[.,]/g, '') + '.' + cleaned.slice(lastSep + 1);
    }
  }

  const n = parseFloat(normalized);
  return Number.isFinite(n) ? n : 0;
}

/** Sepet/sipariş toplamını "£1,234.50" biçiminde yazar. */
export function formatPrice(amount) {
  const n = Number.isFinite(amount) ? amount : 0;
  return `£${n.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}
